module.exports = __webpack_public_path__ + "static/media/HelpIcon.46aa95a3.svg";